module.exports = __webpack_public_path__ + "img/assembly-cp-logo.f345e32d.png";